import React, { useEffect } from 'react'
import Navbar from '../components/Navbar';
import Home from '../components/Home';
import Description from '../components/Description';
import Grid from '../components/Grid';
import Board from '../components/Board';
import Subscribe from '../components/Subscribe';
import Footer from '../components/Footer';
import app from '../Firebase';
import { GithubAuthProvider, 
         getAuth, 
         signInWithRedirect, 
         getRedirectResult, 
         onAuthStateChanged, 
         } 
from "firebase/auth";
import { useHistory } from 'react-router-dom'
import { setUserLogin } 
from '../features/user/UserSlice'
import { useDispatch } from 'react-redux'

function Login() {

    const dispatch = useDispatch()

    const provider = new GithubAuthProvider();
    const auth = getAuth(app);
    const history = useHistory()

  const login = ()=>{
        
    signInWithRedirect(auth, provider);
         getRedirectResult(auth)
        .then((result) => {
            const credential = GithubAuthProvider.credentialFromResult(result);
            if (credential) {
            // This gives you a GitHub Access Token. You can use it to access the GitHub API.
            const token = credential.accessToken;
           

            dispatch(setUserLogin({
                name: user.displayName,
                email: user.email,
                photo: user.photoURL
            }))
            // ...
            }

            // The signed-in user info.
            const user = result.user;
        }).catch((error) => {
            // Handle Errors here.
            const errorCode = error.code;
            // ...
  });

    }

 

    useEffect(() =>{
        onAuthStateChanged(auth, (user) => {
            if (user) {
                dispatch(setUserLogin({
                    name: user.displayName,
                    email: user.email,
                    photo: user.photoURL
                }))

                history.push('/home')
            } 
          });
    }, [])

 
    return (
        <div>
            <Navbar button='Login With Github' clickEvent={login}/>
            <Home/>
            <Description/>
            <Grid/>
            <Board/>
            <Subscribe/>
            <Footer/>
        </div>
    )
}

export default Login
